// extracted by mini-css-extract-plugin
module.exports = {"buttons":"GNcy-vo6CbKj9GCRemRkq"};